import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import SearchIcon from '@mui/icons-material/Search';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import TuneRoundedIcon from '@mui/icons-material/TuneRounded';
import CircularProgress from '@mui/material/CircularProgress';
import { MONTHS } from './dashDummyData';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';

function normalizeItem(item, isUserPill) {
    if (isUserPill) {
        return { val: item.id, label: item.name };
    }
    if (item && typeof item === 'object' && 'value' in item) {
        return { val: item.value, label: item.label || item.value };
    }
    if (item && typeof item === 'object' && 'id' in item) {
        return { val: item.id, label: item.name };
    }
    if (item && typeof item === 'object') {
        return { val: item.name, label: item.name };
    }
    return { val: item, label: item };
}

const HOVER_CLOSE_DELAY = 180;

const FY_MONTH_ORDER = [4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3];
const FY_START_MONTH = FY_MONTH_ORDER[0];                         // April
const FY_END_MONTH = FY_MONTH_ORDER[FY_MONTH_ORDER.length - 1];   // March
const fyPosition = (monthNum) => FY_MONTH_ORDER.indexOf(monthNum);

// function FilterPill({ name, id, list = [], icon, filters, activeDropdown, setActiveDropdown, onToggle, isUserPill = false }) {
//     const selected = filters[id] ?? [];
//     const hasSelections = Array.isArray(selected)
//         ? selected.length > 0
//         : selected !== undefined && selected !== null;
//     const isOpen = activeDropdown === id;
//     const [searchQuery, setSearchQuery] = useState('');
//     const closeTimeoutRef = useRef(null);

//     useEffect(() => {
//         if (!isOpen) setSearchQuery('');
//     }, [isOpen]);

//     useEffect(() => () => {
//         if (closeTimeoutRef.current) clearTimeout(closeTimeoutRef.current);
//     }, []);

//     const handleMouseEnter = useCallback(() => {
//         if (closeTimeoutRef.current) {
//             clearTimeout(closeTimeoutRef.current);
//             closeTimeoutRef.current = null;
//         }
//         setActiveDropdown(id);
//     }, [id, setActiveDropdown]);

//     const handleMouseLeave = useCallback(() => {
//         closeTimeoutRef.current = setTimeout(() => {
//             setActiveDropdown((prev) => (prev === id ? null : prev));
//         }, HOVER_CLOSE_DELAY);
//     }, [id, setActiveDropdown]);

//     const filteredList = list
//         .filter((item) => {
//             if (!item) return false;
//             const { label } = normalizeItem(item, isUserPill);
//             return String(label).toLowerCase().includes(searchQuery.toLowerCase());
//         })
//         .sort((a, b) => {
//             const { val: valA, label: labelA } = normalizeItem(a, isUserPill);
//             const { val: valB, label: labelB } = normalizeItem(b, isUserPill);

//             const checkedA = Array.isArray(selected) ? selected.some(s => String(s) === String(valA)) : String(selected) === String(valA);
//             const checkedB = Array.isArray(selected) ? selected.some(s => String(s) === String(valB)) : String(selected) === String(valB);

//             if (checkedA && !checkedB) return -1;
//             if (!checkedA && checkedB) return 1;

//             return String(labelA).localeCompare(String(labelB), undefined, { sensitivity: 'base', numeric: true });
//         });

//     return (
//         <div
//             className="relative"
//             onMouseEnter={handleMouseEnter}
//             onMouseLeave={handleMouseLeave}
//         >
//             <button
//                 type="button"
//                 onClick={() => setActiveDropdown(isOpen ? null : id)}
//                 aria-expanded={isOpen}
//                 className={`flex items-center gap-1.5 h-8 px-3 rounded-xl text-[11px] font-bold border transition-all duration-150 ${hasSelections
//                     ? 'bg-[#0a2540] border-[#0a2540] text-white shadow-md'
//                     : 'bg-white border-slate-200 text-slate-600 hover:border-slate-300 hover:bg-slate-50'
//                     }`}
//             >
//                 <span className={hasSelections ? 'text-white/70' : 'text-slate-400'}>
//                     {React.cloneElement(icon, { sx: { fontSize: 13 } })}
//                 </span>
//                 <span>{name}</span>
//                 {hasSelections ? (
//                     <span className="bg-white/20 text-white text-[10px] font-extrabold px-1.5 py-0.5 rounded-full min-w-[18px] text-center">
//                         {selected.length}
//                     </span>
//                 ) : (
//                     <KeyboardArrowDownIcon
//                         sx={{
//                             fontSize: 13,
//                             opacity: 0.5,
//                             transform: isOpen ? 'rotate(180deg)' : 'none',
//                             transition: 'transform 0.15s ease',
//                         }}
//                     />
//                 )}
//             </button>

//             {isOpen && (
//                 <>
//                     <div className="absolute top-full left-0 h-1.5 w-full" />
//                     <div className="absolute top-full left-0 mt-1.5 w-56 bg-white border border-slate-200 rounded-2xl shadow-xl p-1.5 flex flex-col gap-0.5 z-50 animate-[fadeIn_0.12s_ease-out]">
//                         <div className="relative flex items-center mb-1 px-1">
//                             <SearchIcon className="absolute left-2.5 text-slate-400" sx={{ fontSize: 13 }} />
//                             <input
//                                 type="text"
//                                 placeholder={`Search ${name}...`}
//                                 value={searchQuery}
//                                 onChange={(e) => setSearchQuery(e.target.value)}
//                                 className="w-full h-7 pl-7 pr-2.5 bg-slate-50 border border-slate-100 rounded-lg text-[11px] text-slate-800 placeholder-slate-400 focus:outline-none focus:border-slate-200 focus:bg-white transition-all"
//                             />
//                         </div>

//                         <div className="max-h-48 overflow-y-auto flex flex-col gap-0.5 custom-scrollbar">
//                             {filteredList.length > 0 ? (
//                                 filteredList.map((item) => {
//                                     const { val, label } = normalizeItem(item, isUserPill);
//                                     const checked = Array.isArray(selected) ? selected.some(s => String(s) === String(val)) : String(selected) === String(val); return (
//                                         <div
//                                             key={val}
//                                             onClick={() => onToggle(id, val)}
//                                             className={`flex items-center gap-2 px-2.5 py-1.5 rounded-xl text-[11px] font-semibold cursor-pointer transition-colors ${checked ? 'bg-slate-50 text-slate-900' : 'text-slate-500 hover:bg-slate-50'
//                                                 }`}
//                                         >
//                                             {checked
//                                                 ? <CheckBoxIcon sx={{ fontSize: 14, color: '#0a2540' }} />
//                                                 : <CheckBoxOutlineBlankIcon sx={{ fontSize: 14, color: '#cbd5e1' }} />
//                                             }
//                                             <span className={checked ? 'font-bold text-slate-900' : ''}>{label}</span>
//                                         </div>
//                                     );
//                                 })
//                             ) : (
//                                 <div className="text-[10px] text-slate-400 text-center py-3 font-medium">
//                                     No results found
//                                 </div>
//                             )}
//                         </div>
//                     </div>
//                 </>
//             )}
//         </div>
//     );
// }

function FilterPill({ name, id, list = [], icon, filters, activeDropdown, setActiveDropdown, onToggle, isUserPill = false, isSingle = false }) {
    const selected = filters[id] ?? [];
    const safeSelected = Array.isArray(selected) ? selected : (selected !== undefined && selected !== null ? [selected] : []);
    const hasSelections = safeSelected.length > 0;
    const isOpen = activeDropdown === id;
    const [searchQuery, setSearchQuery] = useState('');
    const [visibleCount, setVisibleCount] = useState(20);
    const closeTimeoutRef = useRef(null);

    // Reset search query and visibleCount when closed
    useEffect(() => {
        if (!isOpen) {
            setSearchQuery('');
            setVisibleCount(20);
        }
    }, [isOpen]);

    // 1. Create a Set of selected items for O(1) ultra-fast lookups
    const selectedSet = useMemo(() => {
        const set = new Set();
        safeSelected.forEach((s) => set.add(String(s)));
        return set;
    }, [safeSelected]);

    useEffect(() => () => {
        if (closeTimeoutRef.current) clearTimeout(closeTimeoutRef.current);
    }, []);

    const handleMouseEnter = useCallback(() => {
        if (closeTimeoutRef.current) {
            clearTimeout(closeTimeoutRef.current);
            closeTimeoutRef.current = null;
        }
        setActiveDropdown(id);
    }, [id, setActiveDropdown]);

    const handleMouseLeave = useCallback(() => {
        closeTimeoutRef.current = setTimeout(() => {
            setActiveDropdown((prev) => (prev === id ? null : prev));
        }, HOVER_CLOSE_DELAY);
    }, [id, setActiveDropdown]);

    // 2. High-performance filtering and sorting
    const filteredList = useMemo(() => {
        const query = searchQuery.toLowerCase().trim();

        const filtered = list.filter((item) => {
            if (!item) return false;
            if (!query) return true;
            const { label } = normalizeItem(item, isUserPill);
            return String(label).toLowerCase().includes(query);
        });

        return filtered.sort((a, b) => {
            const { val: valA, label: labelA } = normalizeItem(a, isUserPill);
            const { val: valB, label: labelB } = normalizeItem(b, isUserPill);

            const checkedA = selectedSet.has(String(valA));
            const checkedB = selectedSet.has(String(valB));

            if (checkedA && !checkedB) return -1;
            if (!checkedA && checkedB) return 1;

            return String(labelA).localeCompare(String(labelB), undefined, { sensitivity: 'base', numeric: true });
        });
    }, [list, searchQuery, isUserPill, selectedSet]);

    const visibleList = useMemo(() => filteredList.slice(0, visibleCount), [filteredList, visibleCount]);

    // 4. Select All / Deselect All Logic
    const isAllFilteredSelected = useMemo(() => {
        if (filteredList.length === 0) return false;
        return filteredList.every((item) => {
            const { val } = normalizeItem(item, isUserPill);
            return selectedSet.has(String(val));
        });
    }, [filteredList, selectedSet, isUserPill]);

    const handleSelectAllToggle = () => {
        filteredList.forEach((item) => {
            const { val } = normalizeItem(item, isUserPill);
            const valStr = String(val);
            const isChecked = selectedSet.has(valStr);

            if (isAllFilteredSelected && isChecked) {
                // Deselect all filtered items
                onToggle(id, val);
            } else if (!isAllFilteredSelected && !isChecked) {
                // Select all filtered items
                onToggle(id, val);
            }
        });
    };

    return (
        <div
            className="relative"
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <button
                type="button"
                onClick={() => setActiveDropdown(isOpen ? null : id)}
                aria-expanded={isOpen}
                className={`flex items-center gap-1.5 h-8 px-3 rounded-xl text-[11px] font-bold border transition-all duration-150 ${hasSelections
                    ? 'bg-[#0a2540] border-[#0a2540] text-white shadow-md'
                    : 'bg-white border-slate-200 text-slate-600 hover:border-slate-300 hover:bg-slate-50'
                    }`}
            >
                <span className={hasSelections ? 'text-white/70' : 'text-slate-400'}>
                    {React.cloneElement(icon, { sx: { fontSize: 13 } })}
                </span>
                <span>{name}</span>
                {hasSelections ? (
                    <span className="bg-white/20 text-white text-[10px] font-extrabold px-1.5 py-0.5 rounded-full min-w-[18px] text-center">
                        {safeSelected.length}
                    </span>
                ) : (
                    <KeyboardArrowDownIcon
                        sx={{
                            fontSize: 13,
                            opacity: 0.5,
                            transform: isOpen ? 'rotate(180deg)' : 'none',
                            transition: 'transform 0.15s ease',
                        }}
                    />
                )}
            </button>

            {isOpen && (
                <>
                    <div className="absolute top-full left-0 h-1.5 w-full" />
                    <div className="absolute top-full left-0 mt-1.5 w-60 bg-white border border-slate-200 rounded-2xl shadow-xl p-1.5 flex flex-col gap-0.5 z-50 animate-[fadeIn_0.12s_ease-out]">
                        {/* Search Input */}
                        <div className="relative flex items-center mb-1 px-1">
                            <SearchIcon className="absolute left-2.5 text-slate-400" sx={{ fontSize: 13 }} />
                            <input
                                type="text"
                                placeholder={`Search ${name}...`}
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                className="w-full h-7 pl-7 pr-2.5 bg-slate-50 border border-slate-100 rounded-lg text-[11px] text-slate-800 placeholder-slate-400 focus:outline-none focus:border-slate-200 focus:bg-white transition-all"
                            />
                        </div>

                        {/* Select All / Deselect All Toggle Header */}
                        {!isSingle && filteredList.length > 0 && (
                            <div
                                onClick={handleSelectAllToggle}
                                className="flex items-center justify-between px-2.5 py-1.5 mb-1 rounded-lg text-[10px] font-bold bg-slate-100/70 text-slate-700 cursor-pointer hover:bg-slate-200/70 transition-colors"
                            >
                                <div className="flex items-center gap-1.5">
                                    {isAllFilteredSelected ? (
                                        <CheckBoxIcon sx={{ fontSize: 14, color: '#0a2540' }} />
                                    ) : (
                                        <CheckBoxOutlineBlankIcon sx={{ fontSize: 14, color: '#cbd5e1' }} />
                                    )}
                                    <span>{isAllFilteredSelected ? 'Deselect All' : 'Select All'}</span>
                                </div>
                                <span className="text-[9px] text-slate-400 font-normal">
                                    ({filteredList.length})
                                </span>
                            </div>
                        )}

                        {/* Options List */}
                        <div 
                            className="max-h-48 overflow-y-auto flex flex-col gap-0.5 custom-scrollbar"
                            onScroll={(e) => {
                                const { scrollHeight, scrollTop, clientHeight } = e.target;
                                if (scrollHeight - scrollTop <= clientHeight + 1.5 && visibleCount < filteredList.length) {
                                    setVisibleCount(prev => prev + 20);
                                }
                            }}
                        >
                            {visibleList.length > 0 ? (
                                visibleList.map((item) => {
                                    const { val, label } = normalizeItem(item, isUserPill);
                                    const checked = selectedSet.has(String(val));
                                    return (
                                        <div
                                            key={val}
                                            onClick={() => onToggle(id, val)}
                                            className={`flex items-center gap-2 px-2.5 py-1.5 rounded-xl text-[11px] font-semibold cursor-pointer transition-colors ${checked ? 'bg-slate-50 text-slate-900' : 'text-slate-500 hover:bg-slate-50'
                                                }`}
                                        >
                                            {isSingle ? (
                                                checked ? (
                                                    <RadioButtonCheckedIcon sx={{ fontSize: 14, color: '#0a2540' }} />
                                                ) : (
                                                    <RadioButtonUncheckedIcon sx={{ fontSize: 14, color: '#cbd5e1' }} />
                                                )
                                            ) : checked ? (
                                                <CheckBoxIcon sx={{ fontSize: 14, color: '#0a2540' }} />
                                            ) : (
                                                <CheckBoxOutlineBlankIcon sx={{ fontSize: 14, color: '#cbd5e1' }} />
                                            )}
                                            <span className={`truncate ${checked ? 'font-bold text-slate-900' : ''}`}>{label}</span>
                                        </div>
                                    );
                                })
                            ) : (
                                <div className="text-[10px] text-slate-400 text-center py-3 font-medium">
                                    No results found
                                </div>
                            )}

                            {/* Indicator when items exceed render limit */}
                            {visibleCount < filteredList.length && (
                                <div className="text-[9px] text-slate-400 text-center py-2 font-medium bg-slate-50 rounded-md">
                                    Scroll for more...
                                </div>
                            )}
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}

export function MonthMultiSelectPicker({ filters, activeDropdown, setActiveDropdown, onToggle }) {
    const dropdownId = 'monthsDropdown';
    const isOpen = activeDropdown === dropdownId;
    const closeTimeoutRef = useRef(null);

    const FY_MONTH_ORDER = [4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3];
    const selectedMonths = filters.months || [];

    const rangeLabel = useMemo(() => {
        if (selectedMonths.length === 12) return 'Full FY';
        if (selectedMonths.length === 0) return 'Select Months';
        if (selectedMonths.length === 1) return MONTHS[selectedMonths[0] - 1]?.slice(0, 3);

        // Sort selected to show a clean label range representation
        const sorted = [...selectedMonths].sort((a, b) => FY_MONTH_ORDER.indexOf(a) - FY_MONTH_ORDER.indexOf(b));
        return `${MONTHS[sorted[0] - 1]?.slice(0, 3)} (+${selectedMonths.length - 1})`;
    }, [selectedMonths]);

    return (
        <div
            className="relative"
            onMouseEnter={() => {
                if (closeTimeoutRef.current) clearTimeout(closeTimeoutRef.current);
                setActiveDropdown(dropdownId);
            }}
            onMouseLeave={() => {
                closeTimeoutRef.current = setTimeout(() => setActiveDropdown(null), 180);
            }}
        >
            <button
                type="button"
                onClick={() => setActiveDropdown(isOpen ? null : dropdownId)}
                className={`flex items-center gap-1.5 h-8 px-3 rounded-xl text-[11px] font-bold border transition-all duration-150 ${selectedMonths.length > 0 ? 'bg-[#0a2540] border-[#0a2540] text-white shadow-md' : 'bg-white border-slate-200 text-slate-600'
                    }`}
            >
                <CalendarMonthIcon sx={{ fontSize: 13 }} />
                <span>{rangeLabel}</span>
                <KeyboardArrowDownIcon sx={{ fontSize: 13, transform: isOpen ? 'rotate(180deg)' : 'none', transition: 'transform 0.15s' }} />
            </button>



            {isOpen && (
                <div className="absolute top-full right-0 mt-1.5 w-48 bg-white border border-slate-200 rounded-2xl shadow-xl p-1.5 z-50 flex flex-col gap-0.5">
                    <div className="text-[9px] uppercase tracking-wider font-extrabold text-slate-400 px-2 py-1">Months (FY Order)</div>
                    <div
  onClick={() => {
    const isAllSelected = selectedMonths.length === FY_MONTH_ORDER.length;
    FY_MONTH_ORDER.forEach((mNum) => {
      const isChecked = selectedMonths.includes(mNum);
      if (isAllSelected && isChecked) {
        onToggle('months', mNum);
      } else if (!isAllSelected && !isChecked) {
        onToggle('months', mNum);
      }
    });
  }}
  className="flex items-center justify-between px-2.5 py-1.5 mb-1 rounded-lg text-[10px] font-bold bg-slate-100/70 text-slate-700 cursor-pointer hover:bg-slate-200/70 transition-colors"
>
  <div className="flex items-center gap-1.5">
    {selectedMonths.length === FY_MONTH_ORDER.length ? (
      <CheckBoxIcon sx={{ fontSize: 14, color: "#0a2540" }} />
    ) : (
      <CheckBoxOutlineBlankIcon sx={{ fontSize: 14, color: "#cbd5e1" }} />
    )}
    <span>
      {selectedMonths.length === FY_MONTH_ORDER.length ? "Deselect All" : "Select All"}
    </span>
  </div>
  <span className="text-[9px] text-slate-400 font-normal">
    ({FY_MONTH_ORDER.length})
  </span>
</div>
                    <div className="max-h-56 overflow-y-auto custom-scrollbar flex flex-col gap-0.5">
                        {FY_MONTH_ORDER.map((mNum) => {
                            const checked = selectedMonths.includes(mNum);
                            return (
                                <div
                                    key={mNum}
                                    onClick={() => onToggle('months', mNum)}
                                    className={`flex items-center gap-2 px-2.5 py-1.5 rounded-xl text-[11px] font-semibold cursor-pointer transition-colors ${checked ? 'bg-slate-50 text-slate-900' : 'text-slate-500 hover:bg-slate-50'
                                        }`}
                                >
                                    {checked ? <CheckBoxIcon sx={{ fontSize: 14, color: '#0a2540' }} /> : <CheckBoxOutlineBlankIcon sx={{ fontSize: 14, color: '#cbd5e1' }} />}
                                    <span className={checked ? 'font-bold' : ''}>{MONTHS[mNum - 1]}</span>
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}
        </div>
    );
}

function AppliedFilters({ filters, filterDefs, userOpt, filterBarOptions, onToggle, onReset }) {
    const groups = useMemo(() => {
        const result = [];

        filterDefs.forEach((def) => {
            const selected = filters[def.id];
            if (!Array.isArray(selected) || selected.length === 0) return;

            const isUserPill = def.id === 'users';
            const sourceList = def.id === 'roles'
                ? filterBarOptions.roles
                : def.id === 'users'
                    ? userOpt
                    : def.id === 'years'
                        ? def.list
                        : def.list || [];

            const lookup = new Map(sourceList.map((item) => {
                const { val, label } = normalizeItem(item, isUserPill);
                return [String(val), label];
            }));

            result.push({
                id: def.id,
                name: def.name,
                icon: def.icon,
                chips: selected.map((val) => ({
                    val,
                    label: lookup.get(String(val)) ?? String(val),
                })),
            });
        });


        const selectedMonths = filters.months || [];
        if (selectedMonths.length > 0 && selectedMonths.length < 12) {
            const sortedMonths = [...selectedMonths].sort((a, b) => fyPosition(a) - fyPosition(b));

            result.push({
                id: 'months',
                name: 'Months',
                icon: <CalendarMonthIcon />,
                chips: sortedMonths.map((mNum) => ({
                    val: mNum,
                    label: MONTHS[mNum - 1]?.slice(0, 3),
                })),
            });
        }

        return result;
    }, [filters, filterDefs, userOpt, filterBarOptions]);

    const totalChips = groups.reduce((sum, g) => sum + g.chips.length, 0);
    if (totalChips === 0) return null;

    const handleRemove = (groupId, val) => {
        if (groupId === 'months') {
            onToggle('months', val);
            return;
        }
        onToggle(groupId, val);
    };

    return (
        <div className="border-b border-slate-200/70 bg-slate-50/70">
            <div className="max-w-[1600px] mx-auto px-6 py-2.5 flex flex-wrap items-center gap-x-4 gap-y-2">
                <div className="flex items-center gap-1.5 text-[10px] font-extrabold uppercase tracking-wider text-slate-400 shrink-0">
                    <TuneRoundedIcon sx={{ fontSize: 13 }} />
                    Applied
                </div>

                {groups.map((group, gIdx) => (
                    <React.Fragment key={group.id}>
                        {gIdx > 0 && <span className="h-4 w-px bg-slate-200 shrink-0" />}
                        <div className="flex items-center gap-1.5 flex-wrap">
                            <span className="text-[10px] font-bold text-slate-400 shrink-0">{group.name}</span>
                            {group.chips.map((chip) => (
                                <span
                                    key={`${group.id}-${chip.val}`}
                                    className="group flex items-center gap-1 h-6 pl-2.5 pr-1.5 rounded-full text-[11px] font-semibold text-slate-700 bg-white border border-slate-200 shadow-sm hover:border-slate-300 transition-colors"
                                >
                                    {chip.label}
                                    <button
                                        type="button"
                                        onClick={() => handleRemove(group.id, chip.val)}
                                        aria-label={`Remove ${group.name} filter: ${chip.label}`}
                                        className="flex items-center justify-center w-3.5 h-3.5 rounded-full text-slate-400 hover:text-white hover:bg-rose-500 transition-colors"
                                    >
                                        <CloseRoundedIcon sx={{ fontSize: 11 }} />
                                    </button>
                                </span>
                            ))}
                        </div>
                    </React.Fragment>
                ))}

                <button
                    type="button"
                    onClick={onReset}
                    className="ml-auto text-[10px] font-bold text-slate-400 hover:text-rose-600 transition-colors shrink-0"
                >
                    Clear all
                </button>
            </div>
        </div>
    );
}

// ─── FilterBar ────────────────────────────────────────────────────────────────
export default function FilterBar({
    filterDefs,
    filters,
    activeDropdown,
    setActiveDropdown,
    onToggle,
    onReset,
    isGlobalLoading,
    userOpt = [],
    filterBarOptions,
    dropdownRef,
}) {
    return (
        <section
            ref={dropdownRef}
            className="sticky top-0 z-30 border-b border-slate-200/80"
            style={{
                background: 'rgba(255,255,255,0.96)',
                backdropFilter: 'blur(12px)',
                boxShadow: '0 1px 0 rgba(10,37,64,0.06)',
            }}
        >
            <div className="max-w-[1600px] mx-auto px-6 py-3 flex flex-wrap gap-2 items-center">

                {filterDefs[0] && (
                    <FilterPill
                        key={filterDefs[0].id}
                        {...filterDefs[0]}
                        filters={filters}
                        activeDropdown={activeDropdown}
                        setActiveDropdown={setActiveDropdown}
                        onToggle={onToggle}
                    />
                )}

                <FilterPill
                    name="Role"
                    id="roles"
                    list={filterBarOptions.roles}
                    icon={filterDefs.find(f => f.id === 'roles')?.icon || <span />}
                    filters={filters}
                    activeDropdown={activeDropdown}
                    setActiveDropdown={setActiveDropdown}
                    onToggle={onToggle}
                />

                <FilterPill
                    name="User"
                    id="users"
                    list={userOpt}
                    icon={filterDefs.find(f => f.id === 'users')?.icon || <span />}
                    filters={filters}
                    activeDropdown={activeDropdown}
                    setActiveDropdown={setActiveDropdown}
                    onToggle={onToggle}
                    isUserPill={true}
                />

                {filterDefs
                    .filter((f, index) => index !== 0 && !['roles', 'users', 'years'].includes(f.id))
                    .map((f) => (
                        <FilterPill
                            key={f.id}
                            {...f}
                            filters={filters}
                            activeDropdown={activeDropdown}
                            setActiveDropdown={setActiveDropdown}
                            onToggle={onToggle}
                            isSingle={f.isSingle}
                        />
                    ))}

                <div className="flex items-center gap-2 ml-auto">
                    <MonthMultiSelectPicker
                        filters={filters}
                        activeDropdown={activeDropdown}
                        setActiveDropdown={setActiveDropdown}
                        onToggle={onToggle}
                    />

                    {filterDefs.find(f => f.id === 'years') && (
                        <FilterPill
                            {...filterDefs.find(f => f.id === 'years')}
                            filters={filters}
                            activeDropdown={activeDropdown}
                            setActiveDropdown={setActiveDropdown}
                            onToggle={onToggle}
                        />
                    )}
                    {isGlobalLoading && (
                        <CircularProgress size={16} thickness={5} sx={{ color: '#0a2540' }} className="mx-1" />
                    )}

                    <button
                        type="button"
                        onClick={onReset}
                        className="h-8 px-3 flex items-center gap-1 text-[11px] font-bold text-rose-600 bg-rose-50 hover:bg-rose-100 hover:text-rose-900 rounded-xl border border-transparent hover:border-rose-100 transition-all"
                    >
                        <RestartAltIcon sx={{ fontSize: 13 }} /> Reset
                    </button>
                </div>
            </div>

            <AppliedFilters
                filters={filters}
                filterDefs={filterDefs}
                userOpt={userOpt}
                filterBarOptions={filterBarOptions}
                onToggle={onToggle}
                onReset={onReset}
            />
        </section>
    );
}